import React from 'react';
import ItemRenderer from './ItemRenderer';

const GRID = 'grid justify-center [grid-template-columns:repeat(auto-fit,minmax(250px,300px))] gap-4 sm:gap-6';

export default function FolderItems({ items = [], isTrash = false, isSelecting = false, selectedIds, onToggleSelect, className = '' }) {
  const selectionProps = (item) => ({
    isSelecting,
    isSelected: selectedIds?.has(item.id),
    onToggleSelect: () => onToggleSelect?.(item.id),
  });

  if (isTrash) {
    return (
      <div className={`${GRID} ${className}`}>
        {items.map((item, index) => (
          <ItemRenderer key={item?.id ?? index} item={item} isTrash />
        ))}
      </div>
    );
  }

  const pinned   = items.filter(i => i.pinned);
  const unpinned = items.filter(i => !i.pinned);
  const hasPinned = pinned.length > 0;

  const SectionHeader = ({ label }) => (
    <div className="flex items-center gap-2 px-1">
      <span className="text-xs font-medium text-[#7B7B7B] dark:text-[#848484] uppercase tracking-wide flex-shrink-0">
        {label}
      </span>
      <div className="flex-1 h-px bg-[#ECECEC] dark:bg-[#202020]" />
    </div>
  );

  return (
    <div className={`flex flex-col gap-6 ${className}`}>
      {hasPinned && (
        <div className="flex flex-col gap-3">
          <SectionHeader label="Pinned" />
          <div className={GRID}>
            {pinned.map((item, index) => (
              <ItemRenderer key={item?.id ?? index} item={item} {...selectionProps(item)} />
            ))}
          </div>
        </div>
      )}

      {unpinned.length > 0 && (
        <div className="flex flex-col gap-3">
          {hasPinned && <SectionHeader label="Recent" />}
          <div className={GRID}>
            {unpinned.map((item, index) => (
              <ItemRenderer key={item?.id ?? index} item={item} {...selectionProps(item)} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
